import React from 'react';
import './databox.scss';
import Reviews from './DataBlocks/reviews';
import Rating from './DataBlocks/ratings';
import Address from './DataBlocks/address';
import Title from './DataBlocks/title';
import Timings from './DataBlocks/timings';
import Links from './DataBlocks/links';

const DataBox = ({ placeData }) => {
  console.log(placeData);
  if(!placeData.placeId || !placeData) {
    return <div />
  }
  return (
    <div className="databox-container">
      <Title
        title={ placeData.gmaps.name }
      />
      <div className="review">
        <Rating
          rating={placeData.gmaps.rating}
          totalRatingCount={placeData.gmaps.user_ratings_total}
        />
        <Links
          phone={placeData.gmaps.formatted_phone_number || placeData.gmaps.international_phone_number || '#'}
          title={ placeData.gmaps.name }
          placeId={ placeData.placeId }
          website={ placeData.gmaps.website || '#' }
        />
        <Reviews
          reviews={placeData.gmaps && placeData.gmaps.reviews ? placeData.gmaps.reviews : [] }
        />
        <Address
          address={placeData.label || placeData.gmaps.description|| placeData.gmaps.label || '--' }
        />
        <Timings
          timings={placeData.gmaps && placeData.gmaps.opening_hours ? placeData.gmaps.opening_hours.weekday_text : []}
        />
      </div>
    </div>
  )
}

export default DataBox;
